module.exports = __webpack_public_path__ + "img/HPBLUE.b915d571.png";